import {
  arrayBuilderItemSubsequentPageTitleUI,
  radioUI,
  textUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import { VA_FACILITY_TYPE_LABELS } from '../../../constants';
import { vaTreatmentFacilityItemSchema } from '../../../schema';
import { getVaFacilityItem } from './options';

const { facilityType, facilityTypeOther } =
  vaTreatmentFacilityItemSchema.properties;

export default {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(
      ({ formData }) => formData?.treatmentCenterName,
      undefined,
      false,
    ),
    facilityType: radioUI({
      title: 'What kind of VA or military health facility is this?',
      hint: 'Selecting "I’m not sure" won’t negatively affect your claim.',
      labels: VA_FACILITY_TYPE_LABELS,
    }),
    facilityTypeOther: textUI({
      title: 'If you selected “Other,” what kind of facility did you visit?',
      hideIf: (formData, index, fullData) =>
        getVaFacilityItem(formData, index, fullData).facilityType !== 'other',
    }),
  },
  schema: {
    type: 'object',
    properties: {
      facilityType,
      facilityTypeOther,
    },
  },
};
